export enum StatusEnum {
  Normal = 'normal',
  Archived = 'archived',
}
